import React, { createContext, useContext, useState, ReactNode } from "react";
import { paths } from "../utils/constants";

interface SidemenuContextType {
  activeSubmenu: string | null;
  setActiveSubmenu: React.Dispatch<React.SetStateAction<string | null>>;
  isEditCpContent: boolean;
  setIsEditCpContent: React.Dispatch<React.SetStateAction<boolean>>;
  isCreateContent: boolean;
  setIsCreateContent: React.Dispatch<React.SetStateAction<boolean>>;
  cloudPContentId: number;
  setCloudPContentId: React.Dispatch<React.SetStateAction<number>>;
  isOTTPlatform: boolean;
  setIsOTTPlatform: React.Dispatch<React.SetStateAction<boolean>>;
  isMobileMenuOpen:boolean;
  setIsMobileMenuOpen:React.Dispatch<React.SetStateAction<boolean>>;
}

const SidemenuContext = createContext<SidemenuContextType>({
  activeSubmenu: paths.METRICS_CORE_ENGAGEMENT,
  setActiveSubmenu: () => {},
  isEditCpContent: false,
  setIsEditCpContent: () => {},
  isCreateContent: false,
  setIsCreateContent: () => {},
  cloudPContentId: 0,
  setCloudPContentId: () => {},
  isOTTPlatform: true,
  setIsOTTPlatform: () => {},
  isMobileMenuOpen: false,
  setIsMobileMenuOpen: () => {},
});

interface SidemenuProviderProps {
  children: ReactNode;
}

export const SidemenuProvider: React.FC<SidemenuProviderProps> = ({
  children,
}) => {
  const [activeSubmenu, setActiveSubmenu] = useState<string | null>(paths.METRICS_CORE_ENGAGEMENT);
  const [isCreateContent, setIsCreateContent] = useState(false);
  console.log("isCreateContentTop: ", isCreateContent);

  const [isOTTPlatform, setIsOTTPlatform] = useState(true);
  const [isEditCpContent, setIsEditCpContent] = useState(false);
  const [cloudPContentId, setCloudPContentId] = useState(0);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);


  return (
    <SidemenuContext.Provider
      value={{
        activeSubmenu,
        setActiveSubmenu,
        setIsCreateContent,
        setIsEditCpContent,
        isCreateContent,
        isEditCpContent,
        cloudPContentId,
        setCloudPContentId,
        isOTTPlatform,
        setIsOTTPlatform,
        isMobileMenuOpen, 
        setIsMobileMenuOpen
      }}
    >
      {children}
    </SidemenuContext.Provider>
  );
};

export const useSidemenu = () => useContext(SidemenuContext);
